export default __webpack_public_path__ + "static/media/cyber-security.305cfd2b.png";